<template>
  <RevInfoBlock
    :icon="IconInfo"
    :title="i18n(translations.title)"
    variant="info"
  >
    <div>
      {{
        i18n(translations.content, {
          categoryId,
          categoryName,
        })
      }}
    </div>
  </RevInfoBlock>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconInfo } from '@ds/icons/IconInfo'

import translations from './ActionRequired.translations'

const i18n = useI18n()

defineProps<{
  categoryId: number
  categoryName: string
}>()
</script>
